/**
 * A phone number as one an SMS can be sent to (E.164), or null. The browser's copy of
 * backend/src/lib/phone.js toE164, so the user form says "not a number we can text" before
 * saving; the server applies the original. Both are tested against the same cases.
 * It will not guess a country: a number with no country code must be written in full.
 */
const digits = (value: unknown) => String(value ?? '').replace(/\D/g, '')

function wellFormed(allDigits: string): string | null {
    return /^[1-9]\d{7,14}$/.test(allDigits) ? `+${allDigits}` : null
}

export function toE164(phoneCode: string | null | undefined, phoneNumber: string | null | undefined): string | null {
    const rawNumber = String(phoneNumber ?? '').trim()
    const country = digits(phoneCode).replace(/^00/, '')
    let national = digits(rawNumber)
    if (!country) {
        if (rawNumber.startsWith('+')) return wellFormed(national)
        if (national.startsWith('00')) return wellFormed(national.slice(2))
        return null
    }
    if (rawNumber.startsWith('+') || national.startsWith('00')) {
        const international = national.replace(/^00/, '')
        return international.startsWith(country) ? wellFormed(international) : null
    }
    if (country !== '39') national = national.replace(/^0+/, '')
    if (!national) return null
    return wellFormed(`${country}${national}`)
}
